import { useState, useEffect, useCallback } from "react";
import Navbar from "./Navbar/Navbar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Footer from "./Footer/Footer";
import FourPointRigging from "./Calculators/FourPointRigging/FourPointRigging";
import BeamDeflection from "./Calculators/BeamDeflection/BeamDeflection";
import AboutUsNew from "./AboutUS/AboutUs.jsx";
import 'bootstrap/dist/css/bootstrap.min.css';
import Policy from "./policy/Policy";
import Plagiarism from "./plagiarism/plagiarism";
import NetForceCalculator from "./Calculators/Net force/NetForceCalculator";
import BeamPropertiesPro from './Calculators/BeamProperties/BeamPropertiesPro';
import Blogs from "./blogs/blogs";
import BeamPropertiesBlog from "./blogs/BeamPropertiesBlog";
import BeamDeflectionBlog from "./blogs/BeamDeflectionBlog";
import NetforceBlog from "./blogs/NetforceBlog";
import PadeyeBlog from "./blogs/PadeyeBlog";
import PlagiarismCheckerBlog from "./blogs/plagarismblog";

// css
import './Css/AboutUS.css'
import './Css/BeamDeflection.css'
import './Css/BeamProperties.css'
import './Css/Navbar.css'
import './Css/NumberLine.css'
import './Css/Padeye.css'

import LoginPage from "./LoginRegister/Login";
import RegisterPage from "./LoginRegister/Register";
import HumanizerUI from "./Humanizer/Humanizer";
import AIDetectorNewUI from "./AIDetector/AI-Detector";
import ForgotPasswordPage from "./LoginRegister/ForgotPassword";
import GrammarChecker from "./GrammarChecker/GrammarChecker";
import ParaphrasingTool from "./ParaphrasingTool/ParaphrasingTool";
import Summarizer from "./Summarizer/Summarizer";
import { GoogleOAuthProvider } from "@react-oauth/google";
import PadEyeCal from "./Calculators/Padeye/padeye.jsx";
import FourPointRiggingSpreaderBar from "./Calculators/FourPointRiggingSpreaderBar/FourPointRiggingSpreaderBar.jsx";
import BoltTorqueAndPreloadCalculator from "./Calculators/BoltTorqueAndPreloadCalculator/BoltTorqueAndPreloadCalculator.jsx";

function App() {
  const [user, setUser] = useState(null);
  const [theme, setTheme] = useState(() => localStorage.getItem('ook-theme') || 'dark');

  // ✅ Load user on refresh
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  // ✅ Apply theme to <body> and persist
  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('ook-theme', theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  }, []);
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div className="App">
        <BrowserRouter>
          <Routes>

            <Route path="/" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><BeamPropertiesPro /><Footer /></>} unstable_startTransition />
            <Route path="/BeamProperties" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><BeamPropertiesPro /><Footer /></>} unstable_startTransition />
            <Route path="/PadEye" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><PadEyeCal /><Footer /></>} unstable_startTransition />
            <Route path="/FourPointRigging" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><FourPointRigging /><Footer /></>} unstable_startTransition />
            <Route path="/FourPointRiggingSpreaderBar" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><FourPointRiggingSpreaderBar /><Footer /></>} unstable_startTransition />
            <Route path="/BoltTorqueAndPreloadCalculator" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><BoltTorqueAndPreloadCalculator /><Footer /></>} unstable_startTransition />
            <Route path="/Padeyecal" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><PadEyeCal /><Footer /></>} unstable_startTransition />
            <Route path="/BeamDeflection" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><BeamDeflection /><Footer /></>} unstable_startTransition />
            <Route path="/NetForce" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><NetForceCalculator /><Footer /></>} unstable_startTransition />
            <Route path="/AboutUs" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><AboutUsNew /><Footer /></>} unstable_startTransition />

            <Route path="/Policy" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><Policy /><Footer /></>} unstable_startTransition />
            <Route path="/Blogs" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><Blogs /><Footer /></>} unstable_startTransition />
            <Route path="/Blogs/BeamPropertiesBlog" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><BeamPropertiesBlog /><Footer /></>} unstable_startTransition />
            <Route path="/Blogs/PadeyeBlog" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><PadeyeBlog /><Footer /></>} unstable_startTransition />
            <Route path="/Blogs/BeamDeflectionBlog" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><BeamDeflectionBlog /><Footer /></>} unstable_startTransition />
            <Route path="/Blogs/NetforceBlog" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><NetforceBlog /><Footer /></>} unstable_startTransition />
            <Route path="/Blogs/PlagiarismBlog" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><PlagiarismCheckerBlog /><Footer /></>} unstable_startTransition />

            <Route path="/Plagiarism" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><Plagiarism /><Footer /></>} unstable_startTransition />
            <Route path="/Humanizer" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><HumanizerUI /><Footer /></>} unstable_startTransition />
            <Route path="/AIDetector" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><AIDetectorNewUI /><Footer /></>} unstable_startTransition />
            <Route path="/GrammarChecker" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><GrammarChecker /><Footer /></>} unstable_startTransition />
            <Route path="/Paraphraser" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><ParaphrasingTool /><Footer /></>} unstable_startTransition />
            <Route path="/Summarizer" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><Summarizer /><Footer /></>} unstable_startTransition />
            <Route path="/login" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><LoginPage setUser={setUser} /><Footer /></>} />
            <Route path="/register" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><RegisterPage setUser={setUser} /><Footer /></>} />
            <Route path="/forgot-password" element={<><Navbar user={user} setUser={setUser} theme={theme} toggleTheme={toggleTheme} /><ForgotPasswordPage /><Footer /></>} />
          </Routes>
        </BrowserRouter>
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;
